import Button from "components/Button/Button";
import { LegacyRef, useState } from "react";
import "components/InputField/InputField.scss";

interface IProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  numeric?: boolean;
  floating?: boolean;
  innerRef?: LegacyRef<HTMLInputElement>;
  showEditButton?: boolean;
  errors?: string[];
  commaList?: boolean;
  ofValue: string | undefined;
}

const InputKeyField = ({
  label,
  numeric,
  floating,
  innerRef,
  showEditButton, // icon and hide button share the same place so don't use them together on one input.
  errors,
  commaList,
  ofValue,
  ...props
}: IProps) => {
  const [isEditActive, setIsEditActive] = useState<boolean>(false);

  const handlePaste = (event: React.ClipboardEvent<HTMLInputElement>) => {
    if (numeric) {
      const clipboard = event.clipboardData.getData("text");
      if (!/\d/.test(clipboard)) {
        event.preventDefault();
        return;
      }
    }
    event.persist();
  };
  
  return (
    <div className={"input-field " + props.className}>
      {label && <label className="input-field__label">{label}</label>}
      <div className="inputWithButton">
        <input
          {...props}
          ref={innerRef}
          
          className="input-field__input"
          onPaste={handlePaste}
          onKeyDown={(e) => {
              e.persist();
            }
          }
          disabled={!isEditActive}
          defaultValue={isEditActive ? "" : ofValue}
        />
        <Button
          type="button"
          className="button--secondary button--solid"
          icon={isEditActive ? "cross" : "pencil"}
          onClick={() => {
            setIsEditActive(!isEditActive)
          }}
          tabIndex={-1}
        ></Button>
      </div>
      {errors?.length! > 0 && (
        <p>
          {errors?.map((e, i) => (
            <small key={`validation-error-${i}`}>{e}</small>
          ))}
        </p>
      )}
    </div>
  );
};

export default InputKeyField;
